import React, { useState } from 'react';
import { Menu, X, Phone, Clock, User, ShoppingCart, Search, ChevronDown } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const primaryNavItems = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Services',
    path: '/services',
    dropdown: [{
      name: 'Screen Printing',
      path: '/services/screen-printing'
    }, {
      name: 'Embroidery',
      path: '/services/embroidery'
    }, {
      name: 'Custom Apparel',
      path: '/services/custom-apparel'
    }, {
      name: 'Personalized Gifts',
      path: '/services/personalized-gifts'
    }]
  }, {
    name: 'Schools & Teams',
    path: '/schools-teams'
  }, {
    name: 'Custom Apparel',
    path: '/custom-apparel'
  }, {
    name: 'Products',
    path: '/products',
    dropdown: [{
      name: 'Apparel',
      path: '/products?category=apparel'
    }, {
      name: 'Bookish',
      path: '/products?category=bookish'
    }, {
      name: 'Freshies',
      path: '/products?category=freshies'
    }, {
      name: 'Fundraisers',
      path: '/products?category=fundraisers'
    }]
  }, {
    name: 'Fundraisers',
    path: '/fundraisers'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className="sticky top-0 z-50 w-full bg-white shadow-sm border-b border-gray-100" data-id="element-136">
      {/* Top Bar - Contact Info */}
      <div className="bg-purple-600 text-white text-sm py-2 px-4 hidden md:block" data-id="element-137">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-138">
          <div className="flex items-center space-x-6" data-id="element-139">
            <div className="flex items-center space-x-2" data-id="element-140">
              <Clock className="h-4 w-4" data-id="element-141" />
              <span data-id="element-142">Mon-Fri 9AM-5PM</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-143">
              <Phone className="h-4 w-4" data-id="element-144" />
              <a href="tel:9045210580" className="hover:text-teal-200 transition-colors" data-id="element-145">
                (904) 521-0580
              </a>
            </div>
          </div>
          <div className="text-purple-100 text-xs font-medium tracking-wide uppercase" data-id="element-146">
            Leonardtown's Custom Apparel Experts
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="flex justify-between items-center h-20" data-id="element-148">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-149">
            <a href="/" className="flex items-center gap-2" data-id="element-150">
              <img src="https://cdn.magicpatterns.com/uploads/s4GKR2YJgeRhUPczAg63jR/teams_n_tees.webp" alt="Teams 'n Tees Logo" className="h-20 w-auto" data-id="element-151" />
              <span className="sr-only" data-id="element-152">Teams 'n Tees</span>
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8" data-id="element-153">
            {primaryNavItems.map(item => {
            const hasDropdown = 'dropdown' in item;
            if (hasDropdown) {
              return <div key={item.name} className="relative flex items-center" onMouseEnter={() => setActiveDropdown(item.name)} onMouseLeave={() => setActiveDropdown(null)} data-id="element-154">
                    <a href={item.path} className="text-gray-600 hover:text-purple-600 font-medium transition-colors text-sm flex items-center gap-1 h-full py-2" data-id="element-155">
                      {item.name}
                      <ChevronDown className="h-3 w-3" data-id="element-156" />
                    </a>
                    {activeDropdown === item.name && <div className="absolute top-full left-0 pt-2 w-48 z-50" data-id="element-157">
                        <div className="bg-white rounded-lg shadow-lg border border-gray-100 py-2" data-id="element-158">
                          {item.dropdown.map(subItem => <a key={subItem.name} href={subItem.path} className="block px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors" data-id="element-159">
                              {subItem.name}
                            </a>)}
                        </div>
                      </div>}
                  </div>;
            }
            return <a key={item.name} href={item.path} className="text-gray-600 hover:text-purple-600 font-medium transition-colors text-sm flex items-center h-full" data-id="element-160">
                  {item.name}
                </a>;
          })}
          </nav>

          {/* Utility Nav + CTA */}
          <div className="hidden lg:flex items-center space-x-4" data-id="element-161">
            <button className="text-gray-500 hover:text-purple-600 transition-colors p-2" aria-label="Search" data-id="element-162">
              <Search className="h-5 w-5" data-id="element-163" />
            </button>
            <a href="/account" className="text-gray-500 hover:text-purple-600 transition-colors p-2" aria-label="My Account" data-id="element-164">
              <User className="h-5 w-5" data-id="element-165" />
            </a>
            <a href="#cart" className="text-gray-500 hover:text-purple-600 transition-colors p-2 relative" aria-label="Shopping Cart" data-id="element-166">
              <ShoppingCart className="h-5 w-5" data-id="element-167" />
            </a>
            <a href="/contact" className="bg-teal-500 hover:bg-teal-600 text-white px-5 py-2.5 rounded-full font-medium transition-colors shadow-sm hover:shadow-md ml-2" data-id="element-168">
              Get a Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center" data-id="element-169">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-600 hover:text-purple-600 p-2" aria-label="Toggle menu" data-id="element-170">
              {isMenuOpen ? <X className="h-6 w-6" data-id="element-171" /> : <Menu className="h-6 w-6" data-id="element-172" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="lg:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-173">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-174">
            {primaryNavItems.map(item => {
          const hasDropdown = 'dropdown' in item;
          if (hasDropdown) {
            return <div key={item.name} data-id="element-175">
                    <a href={item.path} className="block px-3 py-3 text-base font-medium text-gray-900 hover:text-purple-600 hover:bg-purple-50 rounded-md" onClick={() => setIsMenuOpen(false)} data-id="element-176">
                      {item.name}
                    </a>
                    <div className="pl-6 space-y-1" data-id="element-177">
                      {item.dropdown.map(subItem => <a key={subItem.name} href={subItem.path} className="block px-3 py-2 text-sm text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-md" onClick={() => setIsMenuOpen(false)} data-id="element-178">
                          {subItem.name}
                        </a>)}
                    </div>
                  </div>;
          }
          return <a key={item.name} href={item.path} className="block px-3 py-3 text-base font-medium text-gray-700 hover:text-purple-600 hover:bg-purple-50 rounded-md" onClick={() => setIsMenuOpen(false)} data-id="element-179">
                  {item.name}
                </a>;
        })}
            <div className="pt-4 mt-4 border-t border-gray-100 space-y-2" data-id="element-180">
              <a href="/account" className="flex items-center space-x-2 px-3 py-2 text-gray-600 hover:text-purple-600" data-id="element-181">
                <User className="h-4 w-4" data-id="element-182" />
                <span data-id="element-183">My Account</span>
              </a>
              <a href="#cart" className="flex items-center space-x-2 px-3 py-2 text-gray-600 hover:text-purple-600" data-id="element-184">
                <ShoppingCart className="h-4 w-4" data-id="element-185" />
                <span data-id="element-186">Cart</span>
              </a>
            </div>
            <div className="pt-4 mt-4 border-t border-gray-100" data-id="element-187">
              <div className="flex items-center space-x-2 px-3 py-2 text-gray-600" data-id="element-188">
                <Phone className="h-4 w-4 text-teal-500" data-id="element-189" />
                <a href="tel:9045210580" data-id="element-190">(904) 521-0580</a>
              </div>
              <div className="flex items-center space-x-2 px-3 py-2 text-gray-600" data-id="element-191">
                <Clock className="h-4 w-4 text-teal-500" data-id="element-192" />
                <span data-id="element-193">Mon-Fri 9AM-5PM</span>
              </div>
            </div>
          </div>
        </div>}
    </header>;
}